import React from 'react'
import styled, { css } from 'styled-components'
import { Color } from 'root-constants'
import paypalLogo from 'assets/images/paypal.png'
import { Button } from 'components/Button'

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isTouched: boolean
}

const commonTitleStyles = css`
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: ${Color.DARK};
`

const commonButtonStyles = css`
  margin-top: 16px;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  border-radius: 16px;
`

export const StyledPayPalButton = {
  Root: styled.div`
    z-index: 103;
  `,
  Container: styled.div`
    width: 100%;
    max-width: 290px;
    margin: auto;
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    background-color: ${Color.WHITE};
  `,
  ButtonsContainer: styled.div`
    position: relative;
    z-index: 1;
    min-height: 55px;

    & iframe {
      border-radius: 16px;
      -webkit-tap-highlight-color: transparent;
      opacity: 0.0000000001 !important;
    }
  `,
  FakePaypalButton: styled.button<IButtonProps>`
    width: 100%;
    height: 55px;
    line-height: 55px;
    border-radius: 16px;
    border: none;
    background: #f9c456 url(${paypalLogo}) no-repeat center;
    background-size: 102px 28px;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    padding: 0;
    z-index: 1;
    filter: ${({ isTouched }) =>
      isTouched ? 'brightness(0.95)' : 'brightness(1)'};
  `,

  ModalWrapper: styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(128, 128, 128, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 101;
  `,
  LottieContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  `,
  PaymentStatus: styled.div`
    ${commonTitleStyles};
    padding-bottom: 8px;
    font-size: 24px;
    line-height: 33px;
  `,
  ErrorStatus: styled.div`
    ${commonTitleStyles};
    padding: 10px 15px;
    font-size: 15px;
    line-height: 18px;
  `,
  ErrorButton: styled(Button)`
    ${commonButtonStyles};
    background: ${Color.ERROR};
  `,
  SuccessButton: styled(Button)`
    ${commonButtonStyles};
    background: #60d512;
  `,
}
